<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
        <form [formGroup]="doctoCForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
          <div fxLayout="row wrap" fxLayout.lt-sm="column">
            <div fxFlex="100" class="pr-1"><br></div>

            <mat-tab-group>
              <mat-tab label="Totais">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                    <div fxFlex="30" class="pr-1">
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="60" class="pr-1">Total produtos:</div>
                      <div fxFlex="30" class="pr-1"><b>{{ this.lcto?.totalprodutos | currency:'BRL' }}</b></div>
                      <div fxFlex="10" class="pr-1">
                      <mat-icon>add</mat-icon>
                      </div>

                      <div fxFlex="60" class="pr-1">Desconto itens:</div>
                      <div fxFlex="30" class="pr-1"><b>{{ this.lcto?.descontoValor | currency:'BRL' }}</b></div>
                      <div fxFlex="10" class="pr-1">
                      <mat-icon>remove</mat-icon>
                      </div>

                      <div fxFlex="60" class="pr-1">Líquido dos produtos:</div>
                      <div fxFlex="30" class="pr-1"><b>{{ this.lcto?.totalliquidoprodutos | currency:'BRL' }}</b></div>
                      <div fxFlex="10" class="pr-1">
                      <mat-icon>drag_handle</mat-icon>
                      </div>
                    </div>
                  </div>
                  <div fxFlex="10" class="pr-1"></div>
                  <div fxFlex="60" class="pr-1">
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>(%) Desconto:</mat-label>
                          <input matInput name="descontodoctoPerc" matInput type="text" 
                            (change)="changeDescPerc()" appOnEnter (enterPressed)='changeDescPerc()'
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['descontodoctoPerc']"
                            placeholder="Desc. Perc." currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
    
                      </div>
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Valor de Desconto:</mat-label>
                          <input matInput name="descontodoctoValor" matInput type="text" 
                            (change)="changeDescValor()" appOnEnter (enterPressed)='changeDescValor()'
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['descontodoctoValor']"
                            placeholder="Desc. Valor." currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Frete:</mat-label>
                          <input matInput name="freteValor" matInput type="text"  
                          (change)="recalcTotal()" appOnEnter (enterPressed)='recalcTotal()'
                          (focus)="$event.target.select()"
                            [formControl]="doctoCForm.controls['freteValor']" placeholder="Frete" 
                            currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Seguro:</mat-label>
                          <input matInput name="seguroValor" matInput type="text" 
                          (change)="recalcTotal()" appOnEnter (enterPressed)='recalcTotal()'
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['seguroValor']"
                            placeholder="Seguro" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Despesas Acessórias:</mat-label>
                          <input matInput name="despesaValor" matInput type="text" 
                          (change)="recalcTotal()" appOnEnter (enterPressed)='recalcTotal()'
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['despesaValor']"
                            placeholder="Despesas acessória" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Icms ST:</mat-label>
                          <input matInput name="icmssubstValor" matInput type="text" 
                          (change)="recalcTotal()" appOnEnter (enterPressed)='recalcTotal()'
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['icmssubstValor']"
                            placeholder="ICMS ST" currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="pr-1">
                         <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Icms Desonerado:</mat-label>
                          <input matInput name="icmsDesonValor" matInput type="text" 
                          (change)="recalcTotal()" appOnEnter (enterPressed)='recalcTotal()'
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['icmsDesonValor']"
                            placeholder="ICMS Deson." currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                        </mat-form-field>
                      </div>
                      <div fxFlex="50" class="pr-1" fxLayoutAlign="end center">
                        <span class="mat-label" style="font-weight: bold; font-size: 1.5em;">
                          TOTAL: {{doctoCForm.controls['valortotalDocto'].value | currency:'BRL'}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Impostos">
                <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="end start">
                  <div fxFlex="50" class="pr-1">
                    <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="end start">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
    
                        <mat-label>Base de cálculo ICMS : {{doctoCForm.controls['icmsBasecalculo'].value | currency:'BRL'}}
                        </mat-label>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
    
                        <mat-label>Valor do ICMS : {{doctoCForm.controls['icmsValor'].value | currency:'BRL'}}</mat-label>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
                        <mat-label>Total do IPI : {{doctoCForm.controls['ipiValor'].value | currency:'BRL'}}</mat-label>
    
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
                        <mat-label>Total do PIS : {{doctoCForm.controls['pisValor'].value | currency:'BRL'}}</mat-label>
    
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
    
                        <mat-label>Base Calc. ICMS Substi. Trib. : {{doctoCForm.controls['icmssubstBasecalculo'].value |
                          currency:'BRL'}}</mat-label>
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
                        <mat-label>Valor Aproximado do Tributos: {{doctoCForm.controls['ncmtotalvlimposto'].value |
                          currency:'BRL'}}</mat-label>
    
                      </div>
                    </div>
                  </div>
                  <div fxFlex="50" class="pr-1">
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
                        <!-- <mat-label>Base de cálculo FUNRURAL : {{doctoCForm.controls['valortotalDocto'].value | currency:'BRL'}}</mat-label> -->
                      </div>
                    </div>
                    <div fxLayout="row wrap" fxLayout.lt-sm="column">
                      <div fxFlex="100" class="pr-1" fxLayoutAlign="end start">
                        <mat-label>Total do FUNRURAL : {{doctoCForm.controls['funruralValor'].value | currency:'BRL'}}
                        </mat-label>
    
                      </div>
                    </div>
                    <!-- <mat-label>Valor Total ICMS outros : {{doctoCForm.controls['valortotalDocto'].value | currency:'BRL'}}</mat-label> -->
                    <!-- <mat-label>Valor total ICMS : {{doctoCForm.controls['valortotalDocto'].value | currency:'BRL'}}</mat-label> -->
    
                  </div>
                </div>
              </mat-tab>
    
              <mat-tab label="Informações p/ Custo">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1">
    
                     <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Valor Juros Vendor (+):</mat-label>
                      <input matInput name="infocustojurosvendor" matInput type="text" 
                        (focus)="$event.target.select()" [formControl]="doctoCForm.controls['infocustojurosvendor']"
                        placeholder="Juros Venda (+) " currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                    </mat-form-field>
                  </div>
                  <div fxFlex="100" class="pr-1">
                     <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Valor Outras Despesas (+):</mat-label>
                      <input matInput name="infocustooutrasdesp" matInput type="text" 
                        (focus)="$event.target.select()" [formControl]="doctoCForm.controls['infocustooutrasdesp']"
                        placeholder="Outras despesas (+) " currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                    </mat-form-field>
                  </div>
                  <div fxFlex="100" class="pr-1">
                     <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Valor Outras Receitas (-):</mat-label>
                      <input matInput name="infocustofretepagar" matInput type="text" 
                        (focus)="$event.target.select()" [formControl]="doctoCForm.controls['infocustofretepagar']"
                        placeholder="Frete (+) " currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                    </mat-form-field>
                  </div>
                  <div fxFlex="100" class="pr-1">
                     <mat-form-field appearance="outline" class="full-width">
                      <mat-label>Valor Outras Despesas (-):</mat-label>
                      <input matInput name="infocustodescpgto" matInput type="text" 
                        (focus)="$event.target.select()" [formControl]="doctoCForm.controls['infocustodescpgto']"
                        placeholder="Desconto (-) " currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Dados adicionais">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1">
                  </div>
                  <div fxFlex="100" class="pr-1">
                    <mat-form-field appearance="outline" class="full-width">
                      <textarea matInput name="dadosadicionais" [formControl]="doctoCForm.controls['dadosadicionais']"></textarea>
                      <!-- <input matInput name="icmssubstValor" matInput type="number" 
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['icmssubstValor']"
                            placeholder="ICMS ST"> -->
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Dados adicionais - Fisco">
                <div fxLayout="row wrap" fxLayout.lt-sm="column">
                  <div fxFlex="100" class="pr-1">
                  </div>
                  <div fxFlex="100" class="pr-1">
                     <mat-form-field appearance="outline" class="full-width">
                      <textarea matInput name="dadosadicionaiscontribuinte"
                        [formControl]="doctoCForm.controls['dadosadicionaiscontribuinte']"></textarea>
                      <!-- <input matInput name="icmssubstValor" matInput type="number" 
                            (focus)="$event.target.select()" [formControl]="doctoCForm.controls['icmssubstValor']"
                            placeholder="ICMS ST"> -->
                    </mat-form-field>
                  </div>
    
                </div>
              </mat-tab>
    
            </mat-tab-group>
          </div>
        </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <button class="mb-8" mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
      (click)="this.save();$event.preventDefault();"><mat-icon>save</mat-icon>  {{"SAVE" |
      translate }}
    </button>
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()"><mat-icon>close</mat-icon>  {{"CLOSE" | translate }}</button>
  </div>
</mat-dialog-actions>